import { basics } from "../../basics";

const GradeDescription = (props: any) => {
  const alignClass =
    props.align === "right"
      ? "text-right"
      : props.align === "left"
        ? "text-left"
        : "text-center";
  const colorClass =
    props.color === "black" ? "text-gray-500" : `text-${props.color}-500`;
  return (
    <div className={`${alignClass} text-xs ${colorClass} `}>
      <span className="px-1">{basics.qualityName}</span>
      <span>
        {props.grade === 0
          ? `${basics.perfectQuality}`
          : `${basics.qoodQuality}`}
      </span>
    </div>
  );
};

export default GradeDescription;
